import { render, staticRenderFns } from "./FilterSidebarDynamicFiltersRadiosItem.vue?vue&type=template&id=2da3c0b6&scoped=true&"
import script from "./FilterSidebarDynamicFiltersRadiosItem.vue?vue&type=script&lang=js&"
export * from "./FilterSidebarDynamicFiltersRadiosItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2da3c0b6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2da3c0b6')) {
      api.createRecord('2da3c0b6', component.options)
    } else {
      api.reload('2da3c0b6', component.options)
    }
    module.hot.accept("./FilterSidebarDynamicFiltersRadiosItem.vue?vue&type=template&id=2da3c0b6&scoped=true&", function () {
      api.rerender('2da3c0b6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/assets/js/Components/FilterSidebarDynamicFiltersRadiosItem.vue"
export default component.exports